import type { WebinarModeMetadata } from 'api/generated/models/WebinarModeMetadata';
import type { WebinarModeData } from 'api/types';

/** Маппинг webinarMode из join/start API в формат room metadata. */
export const mapWebinarModeFromJoin = (webinarMode?: WebinarModeMetadata): WebinarModeData | undefined => {
    if (!webinarMode) {
        return undefined;
    }

    return {
        enabled: webinarMode.enabled,
        microDisabled: webinarMode.microDisabled,
        cameraDisabled: webinarMode.cameraDisabled,
        screenShareDisabled: webinarMode.screenShareDisabled,
        speakers: webinarMode.speakers?.map((speaker) => ({
            userId: speaker.userId ?? null,
            identity: speaker.identity ?? null,
        })),
    };
};
